import React from "react";
import { Activity, TrendingUp, Settings as SettingsIcon, ShieldCheck, LogOut, Crosshair, Trophy } from "lucide-react";
import { Logo } from "@/components/Spinner";
import { InstallButton, InstallIconButton, InstallBanner } from "@/components/InstallButton";

// Responsive app shell: fixed left sidebar on desktop, bottom tab bar on mobile.
export default function Layout({ activeView, setActiveView, isAdmin, onLogout, showSetHandicap, showMatchWinner, children }) {
  const items = [
    { key: "matches", label: "Matches", icon: Activity },
    { key: "trading", label: "Trading", icon: TrendingUp },
  ];
  if (showSetHandicap) items.push({ key: "set-handicap", label: "Set Handicap", icon: Crosshair });
  if (showMatchWinner) items.push({ key: "match-winner", label: "Match Winners", icon: Trophy });
  items.push({ key: "settings", label: "Settings", icon: SettingsIcon });
  if (isAdmin) items.push({ key: "admin", label: "Admin", icon: ShieldCheck });

  return (
    <div className="min-h-screen bg-[#0f172a] text-[#e2e8f0]">
      {/* One-time mobile install nudge (auto-shows on first visit, dismissible) */}
      <InstallBanner />
      {/* Desktop sidebar */}
      <aside className="hidden md:flex fixed top-0 left-0 h-screen w-60 flex-col bg-[#0b1120] border-r border-[#1e293b] z-30">
        <div className="px-5 py-6 border-b border-[#1e293b]">
          <Logo size={20} />
          <p className="text-[10px] tracking-[3px] text-[#475569] mt-2 font-semibold">AUTOMATED TENNIS TRADING</p>
        </div>
        <nav className="flex-1 px-3 py-4 space-y-1">
          {items.map((it) => {
            const Icon = it.icon;
            const active = activeView === it.key;
            return (
              <button
                key={it.key}
                onClick={() => setActiveView(it.key)}
                data-testid={`nav-${it.key}`}
                className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-semibold transition-colors ${
                  active ? "bg-[#10b981]/15 text-[#10b981] border border-[#10b981]/40" : "text-[#94a3b8] hover:bg-[#1e293b] hover:text-white border border-transparent"
                }`}
              >
                <Icon size={19} />
                {it.label}
              </button>
            );
          })}
        </nav>
        <div className="p-3 border-t border-[#1e293b]">
          <InstallButton />
          <button
            onClick={onLogout}
            data-testid="logout-btn-sidebar"
            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-semibold text-[#ef4444] hover:bg-[#ef4444]/10"
          >
            <LogOut size={18} /> Sign Out
          </button>
        </div>
      </aside>

      {/* Mobile top bar */}
      <header className="md:hidden sticky top-0 z-30 flex items-center justify-between px-4 py-3 bg-[#0b1120] border-b border-[#1e293b]">
        <Logo size={16} />
        <div className="flex items-center gap-4">
          <InstallIconButton />
          <button onClick={onLogout} data-testid="logout-btn-mobile" className="text-[#ef4444]">
            <LogOut size={20} />
          </button>
        </div>
      </header>

      {/* Main content */}
      <main className="md:ml-60 min-h-screen pb-20 md:pb-0">{children}</main>

      {/* Mobile bottom tab bar */}
      <nav className="md:hidden fixed bottom-0 left-0 right-0 z-30 flex bg-[#0b1120] border-t border-[#1e293b]">
        {items.map((it) => {
          const Icon = it.icon;
          const active = activeView === it.key;
          return (
            <button
              key={it.key}
              onClick={() => setActiveView(it.key)}
              data-testid={`nav-mobile-${it.key}`}
              className={`flex-1 flex flex-col items-center justify-center py-2 gap-0.5 ${active ? "text-[#10b981]" : "text-[#6b7280]"}`}
            >
              <Icon size={20} />
              <span className="text-[10px] font-semibold">{it.label}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
}
